<template>
<div>

<section class="page-content center">
    <br>
    <v-layout row wrap>
    <v-flex xs12 sm12 lg12>
    <p class="total" v-if="confirmado">{{msmTitulo}}</p>
    <p class="total" style="color:#D64550" v-else>{{msmTitulo}}</p>    
    <v-container class="resumo">
    <p >{{msgCorpo}}</p>
    </v-container>
    </v-flex> 
    <v-flex xs12 sm12 lg4 v-if="!boletoGerado">
        <div class="planos-wrapper" style="background:none">
            <div class="list-planos">                    
                <div class="item">
                    <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                    <br>
                    <p class="price"><span>R$</span> {{company.responsibility}}<br></p>
                    <br>
                    <h6 class="desconto">Adesão</h6>
        <a @click="gerarBoleto()" class="button">Gerar Boleto</a>
        </div>
        </div>
        </div>
        </v-flex>
    <v-flex xs12 sm12 lg4 v-if="imprimir">
        <div class="planos-wrapper" style="background:none">
            <div class="list-planos">                    
                <div class="item">
                    <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                    <br>
                    <p class="price"><span>R$</span> {{company.responsibility}}<br></p>
                    <br>
                    <h6 class="desconto">Adesão</h6>
        <a @click="imprimirBoleto()" class="button">Imprimir Boleto</a>
        </div>
        </div>
        </div>
        </v-flex>
    </v-layout>  
    <br>
    <br>
    <br>
    <br> 
</section>
<loading :active.sync="isLoading" 
        :can-cancel="true" 
        color="#7593b4"
        :is-full-page="fullPage"></loading>
<Snackbar ref=chamaSnackbar />
</div>
</template>
<script>
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { baseApiUrl, modelBoleto } from '@/global'
export default {
    components: {Snackbar, Loading},
     data(){
        return{  
            msmTitulo: 'Estamos quase lá!',
            msgCorpo: 'Para concluir a sua proposta é necessário gerar o boleto, para isso, basta clicar no botão abaixo e aguradar. ' ,
            confirmado: true,
            company: [],
            boletoGerado: false,
            cidade: '',
            estado: '',
            bairro: '',
            fullPage: true,  
            isLoading: false, 
            token: '',
            idBoleto: '', 
            imprimir: false
        }               
    },

    mounted : function(){
        localStorage.clear()
        sessionStorage.clear()
        this.pegaParametrosUrl()

    },
    methods: {

 async gerarBoleto(){
     this.company.proposalNumber = this.company.id.replace(/[^\d]+/g,'').substr(0, 8)+Math.floor(10 + Math.random() * 10)
        this.isLoading = true
        this.token = ''
        this.idBoleto = ''
        /*
        //Pegar Token
        try {
              let res = await axios.post("https://p4x.srv.br/api/v1.0/clientes/token",{usuario: '03990914000135',senha:'@orale741'})
              if(res.data != ''){
                  this.token = res.data.token
              }
              } catch (error) {
                  this.isLoading = false
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao se conectar com a plataforma de pagamento, tente mais tarde!","ERRO");
                  this.close()
              }
        */
        //Criando data de vencimeto do boleto
        var datapagvenc = new Date();
        datapagvenc.setDate(new Date().getDate() + 3)
        //Preencher o campos do model de Boleto
        modelBoleto.pagadorDocumentoNumero = this.company.cnpj.replace(/[^\d]+/g,'')
        modelBoleto.pagadorNome = this.company.businessName.substr(0, 39)
        modelBoleto.pagadorEndereco = this.company.address.substr(0, 39) + ', ' + this.company.addressNumber
        modelBoleto.pagadorBairro = this.bairro.substr(0, 19)
        modelBoleto.pagadorDocumentoTipo = 2
        modelBoleto.pagadorCidade = this.cidade.substr(0, 19)
        modelBoleto.pagadorUf = this.estado 
        modelBoleto.pagadorCep = this.company.cep.replace(/[^\d]+/g,'');
        modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
        modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
        //salvando o responsibility e o valor do boleto caso seja anual
        modelBoleto.valorNominal = parseFloat(this.company.responsibility)
        modelBoleto.mensagem = 'Boleto referente ao plano empresarial'        
        modelBoleto.nsu = this.company.proposalNumber
        modelBoleto.nossoNumero = parseInt(this.company.proposalNumber +Math.floor(10 + Math.random() * 99))
        modelBoleto.seuNumero = this.company.proposalNumber +Math.floor(10 + Math.random() * 99)
        
        //Gerando o Boleto e pegando o ID
        try {
              let res = await axios.post(`${baseApiUrl}Pagamentos/gerarBoletoPublico`,modelBoleto)
              if(res.data != ''){
                  this.idBoleto = res.data.id
                  this.imprimirBoleto()

              }              
              } catch (error) {
                  this.isLoading = false
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar Boleto, tente novamente!","ERRO");
                  this.close()                 
              }                        
        
      },     
      
      async imprimirBoleto()
    {
    this.isLoading = true
    //Baixando Boleto PDF
    try {
        /*
        let res = await axios.get(`https://p4x.srv.br/api/v1.0/boletos/${this.idBoleto}/imprimir`,{ responseType: 'arraybuffer', headers: {
             Authorization: 'Bearer ' + this.token,
             'Content-type': 'application/pdf'
           }})
        */
        let res = await axios.get(`${baseApiUrl}Pagamentos/imprimirBoletoPublico?boletoId=${this.idBoleto}`,{ responseType: 'arraybuffer' })
        if(res.data != null){
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [res.data], 
              {type: 'application/pdf'});
              //Build a URL from the file
              const fileURL = URL.createObjectURL(file);
              const link = document.createElement('a');
              link.href = fileURL;
              link.setAttribute('download', 'boleto.pdf'); //or any other extension
              document.body.appendChild(link);
              link.click();
            //Open the URL on new Window
                window.open(fileURL);                  
                
                if(!this.boletoGerado)
                {
                    this.boletoGerado = true
                    this.msmTitulo = 'Proposta confirmada com Sucesso!'
                    this.msgCorpo = 'Com a confirmação dos dados da empresa, bem como dos colaboradores, após o pagamento do boleto, fica autorizado à Orale a dar andamento na proposta ao Contrato Coletivo Empresarial.'
                    this.atualizaCompany()
                }
                else
                {
                    this.imprimir = false
                    this.msmTitulo = 'Boleto impresso com Sucesso!'
                    this.msgCorpo = 'Com a confirmação dos dados da empresa, bem como dos colaboradores, após o pagamento do boleto, fica autorizado à Orale a dar andamento na proposta ao Contrato Coletivo Empresarial.'  
                }
                                                                    
                this.isLoading = false 
        }              
        } catch (error) {
            this.isLoading = false
            var vm = this;            
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao imprimir Boleto, tente novamente ou entre em contato com a Orale!","ERRO");
            this.close()                 
        }
    },

    async pegaParametrosUrl(){
      var params = window.location.search.substring(1).split('?');
      if(params[0] != ''){
      //Criar objeto que vai conter os parametros
      var paramArray = {};

      //Passar por todos os parametros
      for(var i=0; i<params.length; i++) {
          //Dividir os parametros chave e valor
          var param = params[i].split('=');

          //Adicionar ao objeto criado antes
          paramArray[param[0]] = param[1];
          }
      if(paramArray['cp'])
      {   
      await axios.get(`${baseApiUrl}Companies/confirmacaoPublica?id=${paramArray['cp']}`)
            .then(res => { 
                if(res.data != null){                    
                    this.company = res.data
                    if(this.company.situacaoBoleto == "" || this.company.situacaoBoleto == "VENCIDO" || this.company.situacaoBoleto == undefined)
                    { 
                    this.retornoViaCEP()
                    this.confirmado = true 
                    }
                    else
                    if(this.company.situacaoBoleto == "PAGO")
                    {
                        this.confirmado = true
                        this.boletoGerado = true
                        this.msmTitulo = 'Pagamento detectado!'
                        this.msgCorpo = 'Olá, detectamos que você já efetuou o pagamento do boleto, entre em contato com a Orale para mais informações.'
                    } 
                    else
                    if(this.company.situacaoBoleto == "BAIXADO")
                    {
                        this.confirmado = true
                        this.boletoGerado = true
                        this.msmTitulo = 'Boleto Baixado!'
                        this.msgCorpo = 'Olá, O boleto para essa proposta encontra-se baixado. Para mais informações entre em contato com a Apaixonados Saúde Pet.'
                    }    
                    else
                    if(this.company.situacaoBoleto == "REGISTRADO" || this.company.situacaoBoleto == "GERADO")
                    {
                        this.msmTitulo = 'Boleto disponível!'
                        this.msgCorpo = 'Olá, já existe um boleto gerado para a sua proposta, clique abaixo para imprimir.'
                        this.confirmado = true
                        this.imprimir = true
                        this.boletoGerado = true
                        this.idBoleto = this.company.boletoId
                        //this.imprimirBoleto()
                    }                    
                    }
                })
            .catch(() => {
                this.confirmado = false
                this.msmTitulo = 'Algo deu errado na confirmação da proposta!'
                this.msgCorpo = 'Você pode tentar confirmar novamente ou entrar em contato com a Orale.'
            })  
            
        
        }
      }
 
    },

    async atualizaCompany(){
          try {
                await axios.post(`${baseApiUrl}Companies/atualizarBoletoPublico?companyId=${this.company.id}`, {"boletoId" : this.idBoleto, "situacaoBoleto" : "GERADO", "nossoNumero" : modelBoleto.nossoNumero, "status" : "AGUARDANDO PAGAMENTO"}) 
         
              } catch (error) {
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao atualizar situação do boleto, tente novamente","ATENÇÃO")                   
              }
    },

    async retornoViaCEP(){
        if(this.company.cep != '') {
            try {
              let res = await axios.get(`https://viacep.com.br/ws/${this.company.cep.replace(/[^\d]+/g,'')}/json/`) 
              if(res.data != ''){
                  this.cidade = res.data.localidade
                  this.estado = res.data.uf
                  this.bairro = res.data.bairro
                  if(this.cidade == '' || this.estado == '' || this.bairro == '')
                    this.retornoCEP()
              } 
              else
              {
                var vmcep = this;
                vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                this.cidade = ''
                this.estado = ''
                this.bairro = ''
              }             
              } catch (error) {
                  vmcep = this;
                  vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                  this.cidade = ''
                  this.estado = ''
                  this.bairro = ''
              }
          }        
      },

      async retornoCEP(){
            try {
              let res = await axios.post(`${baseApiUrl}APIS4s/EnderecoPublico`, {"cep" : this.company.cep}) 
              if(res.data != ''){
                  this.cidade = res.data.Municipio
                  this.estado = res.data.Uf
                  this.bairro = res.data.Bairro

              }            
              } catch (error) {
                  var vmcep = this;
                  vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
              }         
      },
        
    }

}
</script>

<style>

    .link{
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .imagemcaarj{
        background: url('https://www.apvs.com.br/assets/uploads/parceiros/caarj.png')no-repeat;
        background-size: 500px;
    }
</style>
